<template>
  <div :class="classes"
       :data-type="context.type"
  >

    <vue-autosuggest
        ref="autocomplete"
        v-model="selected"
        :suggestions="suggestions"
        :inputProps="inputProps"
        :getSuggestionValue="getSuggestionValue"
        @input="onInputChange"
        @selected="onSelected"
    >
      <template slot-scope="{suggestion}">
        <!-- TODO - apply bold characters based on the query value address_full value  -->
        <div v-html="highlightResult(suggestion.item)"></div>
      </template>
      <template slot="after-suggestions">
        <div class="is-pulled-right">
          <img class="powered-by-google-logo" width="144" height="18" src="https://developers.google.com/maps/documentation/images/powered_by_google_on_white.png"/>
        </div>
      </template>
    </vue-autosuggest>

    <SpinnerSvg class="loader" v-if="isLoading" />

  </div>
</template>

<script>


import { mapGetters } from 'vuex'
import { VueAutosuggest } from 'vue-autosuggest';
import SpinnerSvg from '@/components/partials/SpinnerSvg.vue';


export default {
  components: {
    VueAutosuggest,
    SpinnerSvg
  },
  props: {
    context: {
      type: Object,
      required: true
    },
  },
  created () {
    this.selected = this.context.model;
  },
  data () {
    return {
      selected: this.model || '',
      suggestions: [],
      searchInputFocusOn: false,
      service: null,
      isLoading: false,
      inputProps: {
        id: "autosuggest__input",
        placeholder: this.placeholder ? this.placeholder : 'Type your address or use the auto-complete',
        class: "form-control",
      },
    }
  },
  metaInfo () {
    // Only load in google places api once
    const google_maps_already_loaded = typeof window.google === 'object' && typeof window.google.maps === 'object' && typeof window.google.maps.places === 'object';
    if( google_maps_already_loaded ){
      this.MapsInit();
    } else {
      return {
        script: [{
          src: `https://maps.googleapis.com/maps/api/js?key=${this.appConfig.g_map_id}&libraries=places`,
          async: true,
          defer: true,
          callback: () => this.MapsInit() // will declare it in methods
        }]
      }
    }
  },
  methods: {
    MapsInit () {
      this.service = new window.google.maps.places.AutocompleteService()
    },
    displaySuggestions (predictions, status) {
      this.isLoading = false;
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.suggestions = []
        return
      }
      const results = predictions.map(prediction => prediction.description)
      this.suggestions = [ {data: results}];
      // console.log('get suggestions', this.suggestions);
    },
    onInputChange() {

    },
    getSuggestionValue(suggestion) {
      // console.log('getSuggestionValue', suggestion.item);
      return suggestion.item;
    },
    onSelected(suggestion) {
      // console.log('onselected', suggestion);
      this.context.model = suggestion.item;
      // this.selected = suggestion;
    },
    highlightResult(text){
      return text.replace(new RegExp(this.selected, "gi"), (match) => `<strong>${match}</strong>`);
    },
  },
  // the magical part
  watch: {
    selected (newValue, oldValue) {
      // console.log('watching ', newValue, oldValue);
      // Only load the predictions if the value has changed and the service is ready
      if (newValue && this.service ) {
        this.isLoading = true;
        this.service.getPlacePredictions({
          input: this.selected,
          types: ['address'],
          componentRestrictions: {country: ["nz"]}
        }, this.displaySuggestions)
      }
    }
  },
  computed: {
    model () {
      return this.context.model
    },
    classes () {
      let classes = `formulate-input-element formulate-input-element--${this.context.type} `;
      if ( this.isLoading ){
        classes = classes + ' is-loading';
      }
      return classes;
    },
    ...mapGetters({
      appConfig: 'getAppConfig',
    })
  },
}
</script>

<style scoped>
  .powered-by-google-logo {
    padding: 15px 15px 0 15px;
  }

  .spinner-loader {
    position: absolute;
    left: -20px;
    top: -20px;
  }

</style>